import { filterByInterface, allowedDepartmentKeys, allowedOpCodesKeys } from "../../utils";
import { IEligibilityRequirement, ESpiffTypes } from "../../../../types/spiffSetup";
import EligibilityTiers from "../EligibilityTiers";

type DepartmentContentProps = {
	spiffType: string;
	requirements: IEligibilityRequirement;
};

const TargetedBonusContent = (props: DepartmentContentProps) => {
	const { spiffType, requirements } = props;
	const formattedRequirements = filterByInterface<IEligibilityRequirement>(
		requirements,
		spiffType === ESpiffTypes.DEPARTMENT ? allowedDepartmentKeys : allowedOpCodesKeys
	);
	const tiersHeaderTitle =
		spiffType === ESpiffTypes.DEPARTMENT
			? formattedRequirements.selectedPayType?.join(", ") + " Type"
			: "Time Lapse \n (" + formattedRequirements.selectedTimeLapse + ")";
	const verticalText =
		spiffType === ESpiffTypes.DEPARTMENT ? (
			<>
				<span>
					Total
					<br />
					Flagged Hours
				</span>
			</>
		) : (
			<>
				<span>
					Tot. Pay
					<br />
					Type Hours
				</span>
			</>
		);
	const informationMessage = formattedRequirements.applyTiersRetroactively ? ["Tiers Applied Retroactively"] : [];
	const verticalTextClassName =
		"!text-sm !text-default !font-montserrat !font-medium !mt-16 !-rotate-90 text-al !text-center " +
		(spiffType === ESpiffTypes.DEPARTMENT ? "!ms-[-32px]" : "!ms-[-24px]");
	const asc = spiffType === ESpiffTypes.DEPARTMENT;
	return (
		<EligibilityTiers
			franchises={[]}
			tiers={formattedRequirements.tiers}
			tiersHeaderTitle={tiersHeaderTitle}
			informationMessage={informationMessage}
			verticalText={verticalText}
			verticalTextClassName={verticalTextClassName}
			commissionColumnsTitle="Bonus"
			spiffType={spiffType}
			selectedDepartment={requirements.selectedDepartment}
			selectedPayType={requirements.selectedPayType}
			selectedOperationCodes={requirements.selectedOperationCodes}
			component={requirements.component}
			asc={asc}
		/>
	);
};

export default TargetedBonusContent;
